import PropTypes from "prop-types"
import { allPass, assocPath, equals, filter, has, is, mergeDeepRight, path, propEq, reduce, reject } from "ramda"
import React from "react"
import getLeavesWhich from "../utils/getLeavesWhich"
import handleFormValidation from "../utils/validation/handleFieldValidation"
import { ValidationMessagePropType, ValidationRulesPropType } from "./form-provider"

class Form extends React.Component {
  static propTypes = {
    forminputdata: PropTypes.object
  }

  static defaultProps = {
    forminputdata: {}
  }

  static contextTypes = {
    rules: ValidationRulesPropType,
    messages: ValidationMessagePropType
  }

  static childContextTypes = {
    form: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired
  }

  getChildContext() {
    return {
      form: this,
      fields: this.state.fields
    }
  }

  constructor(props, context) {
    super(props, context)
    const { rules, messages } = context
    this.messages = messages
    this.state = {
      fields: {},
      rules
    }
  }

  registerField = ({ fieldProps }) => {
    const { fields } = this.state
    const { fieldPath } = fieldProps
    console.log("Before registerField")
    console.log(this.state)
    const isFieldAlreadyExists = !!path(fieldPath, fields)
    if (isFieldAlreadyExists) {
      console.log("Error: Field already exists.")
    }
    const nextFields = assocPath(fieldPath, fieldProps, fields)
    this.setState(
      (prevState) => {
        console.log(mergeDeepRight(prevState.fields, nextFields))
        return { ...prevState, fields: mergeDeepRight(prevState.fields, nextFields) }
      },
      () => {
        console.log("After registerField")
        console.log(this.state)
      }
    )
  }

  unregisterField = ({ fieldProps }) => {
    const { fieldPath } = fieldProps
    console.log("Before unregisterField")
    console.log(fieldProps)

    const predicate = has("fieldPath")
    const reducer = (acc, item) => assocPath(item.fieldPath, item, acc)
    const hasUnregisterFieldPath = propEq("fieldPath", fieldPath)
    const filterFieldPathOut = (field) => reject(hasUnregisterFieldPath)(field)

    this.setState(
      (prevState) => {
        const { fields: prevfields } = prevState
        const allLeaves = getLeavesWhich(predicate)(prevfields)
        const filteredLeaves = filterFieldPathOut(allLeaves)
        const nextFields = reduce(reducer, {})(filteredLeaves)
        return { ...prevState, fields: { ...nextFields } }
      },
      () => {
        console.log("After unregisterField")
        console.log(this.state)
      }
    )
  }

  // return {fieldPath: ["nameEN"], expected: true/false }
  validateField = async (args) => {
    const { fieldProps: explicitFieldProps } = args
    const { fields } = this.state
    const fieldProps = path(explicitFieldProps.fieldPath, fields) || explicitFieldProps
    console.log("validateField fieldProps")
    console.log(fieldProps)
    const validatedField = await handleFormValidation({ fields, fieldProps, form: this })
    console.log("validateField validatedField")
    console.log(validatedField)
    return validatedField
  }

  validate = async () => {
    const { fields } = this.state
    const { onInvalid } = this.props

    const predicate = allPass([is(Object), has("fieldPath")])
    const flattenFields = getLeavesWhich(predicate)(fields)
    console.log("flattenFields")
    console.log(flattenFields)

    const pendingValidateActions = flattenFields.map((fieldProps) => this.validateField({ fieldProps }))
    const validatedFields = await Promise.all(pendingValidateActions)
    console.log("validatedFields")
    console.log(validatedFields)
    const isFormValid = validatedFields.every(propEq("expected", true))

    const invalidFields = filter(propEq("expected", false))(validatedFields)
    const firstErrorFieldPath = path([0, "fieldPath"])(invalidFields)

    const nextFields = validatedFields.reduce((props, field) => {
      if (equals(field.fieldPath, firstErrorFieldPath)) {
        return assocPath(field.fieldPath, { ...field, isFirstError: true })(props)
      }
      return assocPath(field.fieldPath, field)(props)
    }, {})

    this.setState(
      (prevState) => ({
        ...prevState,
        fields: nextFields
      }),
      () => {
        console.log("this.state")
        console.log(this.state)
      }
    )

    if (!isFormValid && onInvalid) {
      const { fields: nextFields } = this.state
      // const invalidFields = filter(propEq("expected", false))(validatedFields)
      console.log("invalidFields")
      console.log(invalidFields)
      onInvalid({ invalidFields, fields: nextFields, form: this })
    }

    console.log("isFormValid")
    console.log(isFormValid)

    return isFormValid
  }

  setErrors = () => {
    const { fields } = this.state
  }

  submit = async (event) => {
    if (event) {
      event.preventDefault()
    }
    const isFormValid = await this.validate()
    const { fields } = this.state
    const { onSubmit, onFailure } = this.props
    if (!isFormValid) {
      if (onFailure) onFailure()
      return
    }
    if (onSubmit) onSubmit({ fields })
  }

  render() {
    const { children, ...rest } = this.props
    return (
      <form onSubmit={this.submit} noValidate {...rest}>
        {children}
      </form>
    )
  }
}

export default Form
